<template>
  
    <div class="payment-details" v-if="payment.constructor === Object && Object.keys(payment).length !== 0 ">
        <p>Mode de paiement : {{ payment.payment_method.display_name }}</p>
        <div v-if="details">
            <p>Référence Front Web: {{ payment.reference}}</p>
            <p v-if="payment.erp_id">Référence SAP: {{ payment.erp_id}}</p>
            <p v-if="payment.method_specific_reference">
            Référence mode de paiement : {{ payment.method_specific_reference }}
            </p>
            <p v-if="payment.reception_date">
            Date de réception du paiement : {{ payment.reception_date | moment-date-compact }}
            </p>

            <div v-if="payment.payment_method.name == 'unit-check'">
                <p>Emetteur du chèque : {{ payment.check_name }}</p>
                <p>Date d'émission du chèque : {{ payment.check_issue_date | moment-date-compact }}</p>
            </div>

            <div v-if="payment.intermediary_business">
                <p>Payeur : {{ payment.intermediary_business.name }} 
                    <span v-if="payment.intermediary_business.erp_id">({{ payment.intermediary_business.erp_id }})</span></p>
            </div>

            <div>
                <p>Montant : {{ (payment.amount / 100).toFixed(2) }}€</p>
            </div>
        </div>
        <hr v-if="details">
    </div>
</template>

<script type="text/babel">
  export default 
  {
    name: "PaymentItem",
    
    props: {
        payment: {
            type: Object,
            required: true,
            default: function () {
                return { }
            }
        },
        details: Boolean
    },

    data () {
      return {}
    },
  }
</script>

<style lang="scss" scoped>
    .payment-status { font-weight: bold; }
    .payment-details { 
        margin-top: 5px;

        p {
            margin-bottom: 0;
        }
    }
</style>



// WEBPACK FOOTER //
// client/components/Payment/Item.vue